import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import BaseLayout from './BaseLayout';
import StaticFooter from '../partials/footer/StaticFooter';
import Hero from '../partials/Hero';
import TeamIntro from '../partials/home/legacy/TeamIntro';
import { Data, Iframe } from '../components';
import FooterCTA from '../partials/footer/FooterCTA';
import ProductOverview from '../partials/product/ProductOverview';

const DownloadRequestLandingPageLayout = ({
  article: {
    frontmatter: {
      seoTitle,
      description,
      hero,
      leftColumnContent,
      rightColumnContent,
      showProductOverview,
      showFooterCTA,
    },
  },
  topBlock,
  nodeType,
}) => (
  <BaseLayout noFooter headerProps={{ sticky: false, showNav: false }}>
    <Helmet
      title={seoTitle}
      meta={[
        { name: 'description', content: description },
        { name: 'robots', content: 'noindex, follow' },
        { name: 'node-type', content: nodeType },
      ]}
    />
    <Hero
      contrast={false}
      className="u-gradient--teal-brightTeal"
      particles={false}
    >
      <div className="hero-content">
        <div className="container">
          <div className="row row--xlargeGutter@medium u-flexMiddle">
            <div className="column-6@medium u-contrast u-textCenter u-textLeft@medium">
              {hero.headingSub && (
                <h4 className="u-textMuted u-textFluid--xlarge u-mb--regular">
                  {hero.headingSub}
                </h4>
              )}
              <h1 className="hero-title u-textFluid--h2-h3 u-mt--remove">
                <Data>{hero.heading}</Data>
              </h1>
              <div className="hero-titleSub">
                <Data markdown>{hero.blurb}</Data>
              </div>
            </div>
            <div className="column-6@medium">
              <div id="form" className="hero-formWrapper">
                <h3 className="u-textFluid--xlarge u-mb--large u-textCenter u-textLeft@medium">
                  <Data>{hero.form.heading}</Data>
                </h3>
                <Iframe title={hero.form.heading} src={hero.form.embed} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Hero>
    {topBlock && topBlock}
    <section>
      <div className="row row--collapse landingPage__contentBlockOverrides">
        <div className="column-6@large landingPage__contentBlock--left u-bgPanel">
          <div className="container container--small">
            <div className="row landingPage__contentBlock-row">
              <div className="column-9@medium">
                <div className="landingPage__contentBlock-content">
                  <Data markdown>{leftColumnContent}</Data>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="column-6@large landingPage__contentBlock--right u-contrast">
          <div className="container container--small">
            <div className="row landingPage__contentBlock-row">
              <div className="column-9@medium">
                <div className="landingPage__contentBlock-content">
                  <Data markdown>{rightColumnContent}</Data>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <TeamIntro
      cta={{
        label: hero.form.heading,
        url: '#form',
      }}
    />
    {showProductOverview && (
      <div className="container">
        <ProductOverview />
      </div>
    )}
    {showFooterCTA && <FooterCTA />}
    <StaticFooter />
  </BaseLayout>
);

DownloadRequestLandingPageLayout.propTypes = {
  article: PropTypes.object.isRequired,
  topBlock: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  nodeType: PropTypes.string.isRequired,
};

export default DownloadRequestLandingPageLayout;
